import axios from "axios";
import { getCookie } from "../utils";
import toast from "react-hot-toast";

const axiosInstance = axios.create({
  baseURL:
    process.env.API_BASE_URL ||
    "https://api.societyofaquacultureprofessionals.org/api",
  // baseURL: "http://localhost:5002/api",
  withCredentials: true,
});

axiosInstance.interceptors.request.use((config) => {
  const token = getCookie("token");
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.message;

    if (status === 401 && message === "Session expired. Please login again.") {
      toast.error(message);

      document.cookie.split(";").forEach((cookie) => {
        document.cookie = cookie
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/");
      });

      window.location.href = "/";
    } else if (
      status === 403 ||
      message === "Your account role is missing. Please sign in again."
    ) {
      document.cookie.split(";").forEach((cookie) => {
        document.cookie = cookie
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/");
      });

      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
